import React from "react";
import PropTypes from "prop-types";
import {
  SIGNOL_COLOUR_NAMES,
  setColourShadeIfMissing,
} from "@signolteam/shared/colours";
import AppUtils from "@src/utils/appUtils";
import Icon from "./Icon";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

const MessageBanner = ({
  color = "error",
  title = "",
  message = "",
  icon = "timer",
}) => {
  const checkColorFormat = (str) => {
    const hexRegex = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/;
    const validColors = SIGNOL_COLOUR_NAMES;

    if (hexRegex.test(str)) {
      return { type: "style", string: str };
    } else if (validColors.includes(str.toLowerCase())) {
      return {
        type: "class",
        string: "bg-" + setColourShadeIfMissing(str, 300),
      };
    } else {
      return { type: "class", string: "bg-primary-300" };
    }
  };

  const bgColor = checkColorFormat(color);

  return (
    <div
      className={`w-full text-white flex justify-center ${bgColor.type === "class" ? bgColor.string : ""}`}
      style={{
        backgroundColor: bgColor.type === "style" ? bgColor.string : ``,
      }}
    >
      <div className="w-full lg:h-32 flex" style={{ maxWidth: "1500px" }}>
        <div className="w-2/12 md:w-1/12 flex justify-center items-center mr-4">
          <Icon
            name={icon}
            textColor="white"
            backgroundColor="transparent"
            padding={false}
            centered={false}
            className="w-3xl h-3xl"
            size="lg"
          />
        </div>
        <div className="flex flex-col justify-center w-10/12 p-4 lg:p-0 text-left">
          <span className="font-bold">{title}</span>
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
};

export const messageBannerControls = {
  color: {
    ...COMMON_CONTROLS.colour_name,
    propType: PropTypes.string,
    description: "Banner background, Allows names, shades and hex",
    options: [...COMMON_CONTROLS.colour_name.options, "primary-600", "#884400"],
  },
  title: {
    propType: PropTypes.string.isRequired,
    description: "Message title",
    controlType: "text",
  },
  message: {
    propType: PropTypes.string.isRequired,
    description: "Message content",
    controlType: "text",
  },
  icon: {
    ...COMMON_CONTROLS.icon_name,
    description: "Icon name (displayed in white)",
  },
};

MessageBanner.propTypes = AppUtils.getPropTypeFromControls(
  messageBannerControls,
);

export default MessageBanner;
